import React from "react";
import { BooleanAnswerFormat, TextChoiceDefinition } from "../../../../types/Survey";
import TextChoiceList from "../../Components/TextChoiceList/TextChoiceList";
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import useTranslate from "../../../../hooks/useTranslate";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let translations = useTranslate(["yes-label-text", "no-label-text"]);
    let currentResult = props.result as QuestionResultModel;
    let answerFormat = props.answerFormat as BooleanAnswerFormat;

    let textChoices: TextChoiceDefinition[] = [
        { type: "TextChoice", value: "True", text: translations["yes-label-text"], primary: true },
        { type: "TextChoice", value: "False", text: translations["no-label-text"] }
    ];

    return <SurveyFormItem
        label={props.label}
        variant={props.variant}
        useFieldsetFormat={props.useFieldsetFormat}
        index={props.index}>
        <TextChoiceList
            variant={props.variant}
            textChoices={textChoices}
            style={answerFormat.style ?? "Single"}
            selectedChoices={currentResult.Answer ? [currentResult.Answer] : []}
            onChangeChoices={(choices) => props.onResultChange({ ...props.result, Answer: choices.length > 0 ? choices[0] : "" } as QuestionResultModel)} />
    </SurveyFormItem>;
}